<template>
  <div class="checkout-header-controls" role="navigation" aria-label="Navigation">
    <CheckoutHeaderControl aria-label="Go Back" :previous="true" class="mr-2" />
    <CheckoutHeaderControl aria-label="Go Forward" :next="true" class="mr-2" />
  </div>
</template>

<script setup lang="ts">
import CheckoutHeaderControl from '@/components/shared/header/CheckoutHeaderControl.vue'
</script>

<style lang="scss" scoped>
.checkout-header-controls {
  display: flex;
  justify-content: flex-end;
  width: auto;

  @include media-breakpoint(md) {
    width: 141px; // match the logo width
  }
}
</style>
